import ActionTypes from '../constants/ActionTypes';

const initialState = {
  isFetching: false,
  didInvalidate: false,
  items: [],
  // filters: [],
  // totalRows: 0,
  // startDate: undefined
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_WORK_HISTORY_STATUS:
      return {
        ...state,
        items: [],
        totalRows: 0,
        isFetching: true,
        didInvalidate: false
      }

    case ActionTypes.RECEIVE_WORK_HISTORY_STATUS:
      return {
        ...state,
        isFetching: false,
        didInvalidate: false,
        items: action.items,
        // filters: action.items.filters,
        totalRows: action.items.detailData.length,
        // startDate: action.items.Start_time_min,
        lastUpdated: action.receivedAt
      }
    case ActionTypes.CLEAR_WORK_HISTORY_STATUS:
      return {
        ...state,
        isFetching: false,
        didInvalidate: false,
        items: [],
        // filters: [],
        totalRows: 0,
      }

    default:
      return state
  }
}